import { render, staticRenderFns } from "./RelatorioTaxaFundoGarantidorRetrato.vue?vue&type=template&id=6012e870"
import script from "./RelatorioTaxaFundoGarantidorRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaFundoGarantidorRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaFundoGarantidorRetrato.vue?vue&type=style&index=0&id=6012e870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports